import React, { useContext } from 'react';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import {
	ApkAssignmentContext,
	IApkAssignmentContext,
} from '../../ApkAssignment/apkAssignmentState/apkAssignmentContext';

export const ModalWindows: React.FC = () => {
	const { resetChanges, updateModuleDataAfterSaving, changeTypeOfModalWindow, sendChanges, typeOfModalWindow } =
		useContext<IApkAssignmentContext>(ApkAssignmentContext);

	const handleConsentEvent = () => {
		resetChanges();
		updateModuleDataAfterSaving();
		changeTypeOfModalWindow(null);
	};

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow}>
			<ModalToConfirm
				onConsentEvent={resetChanges}
				onFailureEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'toConfirmFieldsClearing'}
				description="cancelSaveInfo"
			/>
			<ModalToConfirm
				onConsentEvent={sendChanges}
				onFailureEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'toConfirmSendChanges'}
				description="saveInfo"
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleConsentEvent}
				isVisible={typeOfModalWindow === 'success'}
				description="savedSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileSaving"
			/>
			<ModalSentError
				onConsentEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'apkLimit'}
				description="cannotAssignSoManyApk"
			/>
			<ModalSentError
				onConsentEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'apkOfSameType'}
				description="cannotAssignApkSameType"
			/>
			<ModalSentError
				onConsentEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'restaurantAlreadyHasSelectedApkType'}
				description="selectedApkTypeAlreadyAssigned"
			/>
		</ModalWrapper>
	);
};
